webpackJsonp([24785148491759],{

/***/ 475:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulMember":{"name":"Christopher Louie Lu","designation":"Co-Founder","thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/26Zz5FdLCMewY8IEasekoW/ec5982f8b9f6e2a0c384d7897cbe1830/Louie.jpg"}},"content":{"content":"![blogMSA003L](//images.contentful.com/1o5ly3na7qu2/1NeFHBZnakagAIWgewEEo8/e4dba58cf054d620707f7d5ef1b60345/blogMSA003L.JPG)\n\n__Christopher Louie Lu__\n- MSA Co-Founder\n- Amateur astronomer, astrophotographer, and astronomy lecturer\n- Secretary, Astronomical League of the Philippines"}}},"pathContext":{"id":"c1izq31sK6SyYaMKoWQua2I"}}

/***/ })

});


// WEBPACK FOOTER //
// path---member-christopher-louie-lu-3d1254cece0c22e1ac34.js